export default "__VITE_ASSET__Q63lRGmI__"